module.exports = __webpack_public_path__ + "static/img/arrow-left.8c538de0.svg";